import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CollectionsPage = lazy(() => import('./pages/CollectionsPage'));

export const CmsRoutes: RouteObject = {
  path: 'collections',
  children: [
    { path: '', element: <CollectionsPage />, handle: { crumb: 'CMS & Collections' } },
  ],
};
